import React from 'react';

import { Box } from '@mui/material';

/**
 * Shared action footer for dialogs. It keeps actions outside the scrollable
 * body and applies the single modal-footer spacing/background contract.
 */
const OlcModalFooter = ({ children, className = '', ...props }) => (
  <Box className={`olcModalFooter ${className}`.trim()} {...props}>
    {children}
  </Box>
);

export default OlcModalFooter;
